import mapValuesToRequest, { IRequestBody } from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'
import { IRoom, RoomType } from './index'

export default function(api: GlobalFetch) {
  return async function(
    calendarId: number,
    roomId: IRoom[keyof Pick<IRoom, 'id'>],
    room: IRequestValues,
  ) {
    const requestBody: IRequestBody = mapValuesToRequest(calendarId, {
      ...room,
      id: roomId,
    })
    const response = await api.fetch(`/api/v2/room/update`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}

export interface IRequestValues {
  name?: string
  type?: RoomType
  description?: string

  widget?: number

  size?: any
  additionalEquipment?: any

  roomSize?: number
  additionalBeds?: number
  modified: boolean
  singleBed?: number
  doubleBed?: number

  customColor?: string
  position?: number
}
